import { rem, size } from 'polished';
import styled, { css, CSSObject } from 'styled-components';

import { blue, slate } from '@vimeo/iris/color';
import { DismissX, Search } from '@vimeo/iris/icons';

const inputWidth = 180;
export const Input = styled.input`
  border: none;
  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled(Search)`
  ${size(rem(22)) as CSSObject};
  path {
    fill: ${slate(200)};
  }
`;

export const CancelIcon = styled(DismissX)`
  ${size(rem(20)) as CSSObject};
  path {
    fill: ${slate(200)};
  }
`;

export const Button = styled.button`
  ${size(rem(38)) as CSSObject};
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:active,
  &:focus {
    outline: none;
  }
`;

export const InputWrapper = styled.div`
  position: absolute;
  z-index: 110;
  background-color: white;
  display: flex;
  padding: 0 ${rem(6)};
  border: 1px solid ${slate(200)};
  ${renderFocusStyles}
`;

function renderFocusStyles({ focused }: { focused: boolean }) {
  if (!focused) {
    return;
  }

  return css`
    outline: ${blue(500)} auto 5px;
  `;
}

export const OuterWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: ${rem(inputWidth)};
`;
